module.exports = __webpack_public_path__ + "img/7.2ace3dd8.jpg";